
import React from 'react';
import { LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { SidebarFooter, SidebarMenuItem, SidebarMenuButton, useSidebar } from '@/components/ui/sidebar';
import { useIsMobile } from '@/hooks/use-mobile';

interface AdminSidebarFooterProps {
  onSignOut: () => void;
  userEmail?: string;
}

export function AdminSidebarFooter({ onSignOut, userEmail }: AdminSidebarFooterProps) {
  const { expanded } = useSidebar();
  const isMobile = useIsMobile();

  return (
    <SidebarFooter className="mt-auto border-t p-4">
      <SidebarMenuItem>
        <SidebarMenuButton 
          tooltip="Logout" 
          onClick={onSignOut}
          className="text-gray-600 hover:text-red-600 cursor-pointer"
        >
          <LogOut className="mr-2 h-4 w-4" />
          {(expanded || isMobile) && <span>Logout</span>}
        </SidebarMenuButton>
      </SidebarMenuItem>
      {userEmail && (expanded || isMobile) && (
        <div className="mt-2 text-xs text-gray-500 px-2">
          <span>Logged in as: {userEmail}</span>
        </div>
      )}
    </SidebarFooter>
  );
}
